import * as React from 'react'

const ThemeContext = React.createContext<{
  theme: string
  setTheme: (theme: string) => void
}>({ theme: 'dark', setTheme: () => {} })

export function ThemeProvider({ children, ...props }: { children: React.ReactNode }) {
  const [theme, setTheme] = React.useState('dark')
  
  React.useEffect(() => {
    const root = window.document.documentElement
    root.classList.remove('light', 'dark')
    root.classList.add(theme)
  }, [theme])
  
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => React.useContext(ThemeContext)
